// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/d0b6c0b7f12172984a32.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"548f410e6b3d27794fb0","145":"c5d3addf70a51d8a7087","146":"eaf08cf919386d86402c"}[chunkId] + ".chunk.js";
};